import React, { useState, useEffect } from "react";
import { Container, CircularProgress, Box } from "@mui/material";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Calendar from "./components/Calendar";
import Login from "./components/Login";
import Home from "./components/Home";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import SubmitWorkshop from "./components/SubmitWorkshop";
import Scoreboard from "./components/Scoreboard";

const VALID_ROLES = ['participant', 'organizer'];

const getStoredRole = () => {
  const saved = localStorage.getItem("role");
  return VALID_ROLES.includes(saved) ? saved : null;
};

function App() {
  const [user, setUser] = useState(null);
  const [role, setRole] = useState(getStoredRole);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUser(user);
      } else {
        setUser(null);
      }
      setIsLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const handleSetRole = (role) => {
    setRole(role);
    if (role === null) {
      localStorage.removeItem("role");
    } else {
      localStorage.setItem("role", role);
    }
  };

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress sx={{ color: '#22c55e' }} />
      </Box>
    );
  }

  return (
    <Router>
      <Container maxWidth={false} disableGutters>
        <Routes>
          <Route path="/" element={<Home setRole={handleSetRole} />} />
          <Route
            path="/login"
            element={
              role === "organizer" ? (
                <Login setUser={setUser} />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/calendar"
            element={
              role === "participant" || (role === "organizer" && user) ? (
                <Calendar role={role} setRole={handleSetRole} />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route path="/submit" element={<SubmitWorkshop />} />
          <Route path="/punktacja" element={<Scoreboard role={role} />} />
        </Routes>
      </Container>
    </Router>
  );
}

export default App;